<template>
  <div :class="isVertical ? 'header-vertical' : 'header-horizontal'" :style="{ background: color }" />
</template>

<script lang="ts">
  export default {
    name: 'BaseDivider',
    props: {
      color: {
        type: String,
        default: '#E7E8EC',
      },
      isVertical: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped lang="scss">
  .header {
    &-horizontal {
      width: 100%;
      height: 1px;
    }
    &-vertical {
      height: 100%;
      width: 1px;
    }
  }
</style>
